var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{class:[
    'ticket-timer-container',
    _vm.isZkm ? 'ticket-timer-container-zkm' : 'ticket-timer-container-regular',
  ],attrs:{"column":_vm.$vuetify.breakpoint.xsOnly}},[_c('v-flex',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('div',{staticClass:"ticket-container"},[_c('span',{class:['ticket-container-title', _vm.isZkm && 'ticket-container-title-zkm']},[_vm._v("\n          "+_vm._s(_vm.$t('remainingTime'))+"\n        ")]),_c('span',{staticClass:"timer",attrs:{"translate":"no"}},[_vm._v(_vm._s(_vm.timer))])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }